import { render, staticRenderFns } from "./YouthAmbassadors.vue?vue&type=template&id=3bf25dec"
import script from "./YouthAmbassadors.vue?vue&type=script&lang=js"
export * from "./YouthAmbassadors.vue?vue&type=script&lang=js"
import style0 from "./YouthAmbassadors.vue?vue&type=style&index=0&id=3bf25dec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports